export default __webpack_public_path__ + "static/media/restart.ec53869d.svg";